export const asyncTaskApi = {
  asyncTaskListDockTask: '/clouddm/console/api/v1/asynctask/dockTask/listDockTask',
  asyncTaskCancelTask: '/clouddm/console/api/v1/asynctask/dockTask/cancelTask',
  asyncTaskPauseTask: '/clouddm/console/api/v1/asynctask/dockTask/pauseTask',
  asyncTaskRetryTask: '/clouddm/console/api/v1/asynctask/dockTask/retryTask',
  asyncTaskResumeTask: '/clouddm/console/api/v1/asynctask/dockTask/resumeTask'
};
